export enum OralExaminationChartFields {
  OralDrawing = 'OralDrawing',
}

export const OralExaminationChartFormDefaultValues = {
  [OralExaminationChartFields.OralDrawing]: '',
};
